<template>
  <BaseLandingWithoutTabs
    :faq-id="13">
    <template #header>
      <div>{{$t('renew_header_boat')}}</div>
    </template>
  </BaseLandingWithoutTabs>
</template>

<script>
import BaseLandingWithoutTabs from '@/components/BaseLandingWithoutTabs.vue'

export default {
  name: 'LandingBoat',
  components: {
    BaseLandingWithoutTabs
  }
}
</script>
